import { Tabs } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import PageLoader from "../../components/sub/PageLoader";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../helpers/NotificationHelpers";
import { useSelector } from "react-redux";
import { LIMIT_PER_PAGE } from "../../helpers/constants";
import { GetTargetApprovalsApi } from "../../api/approvals/GetTargetApprovalsApi";
import TargetApprovalsTable from "../../components/tables/TargetApprovalsTable";
import TargetApprovalActionApi from "../../api/approvals/TargetApprovalActionApi";

const { TabPane } = Tabs;

function TargetApprovals() {
  const [data, setData] = useState("");
  const [allPage, setAllPage] = useState(1);
  const [pendingPage, setPendingPage] = useState(1);
  const [approvedPage, setApprovedPage] = useState(1);
  const [rejectedPage, setRejectedPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("all");
  const proHeight = document.body.clientHeight;
  const positionState = useSelector((state) => state.positionState.value);

  useEffect(() => {
    setLoading(true);
    positionState?.id && getTargetApprovals(allPage, "");
  }, [positionState]);

  // get all data
  async function getTargetApprovals(num, status) {
    setTableLoading(true);
    const apiResponse = await GetTargetApprovalsApi(
      num,
      status,
      positionState?.id,
      LIMIT_PER_PAGE
    );
    if (apiResponse.message === "success") {
      setData({
        approvals: apiResponse?.assignedTargetProgresses,
        totalCount: apiResponse?.totalCount,
        page: apiResponse?.page,
        limit: apiResponse?.limit
      });
    }
    setLoading(false);
    setTableLoading(false);
  }

  // approve and reject
  async function approveApproval(id, action, from) {
    setTableLoading(true);
    const apiResponse = await TargetApprovalActionApi(id, action);
    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.message === "Approval status updated successfully") {
      openNotificationSuccess("bottomRight", apiResponse.message);
      if (from === "pending") {
        if (data?.approvals?.length === 1) {
          changeTablePage(pendingPage === 1 ? pendingPage : pendingPage - 1);
        } else {
          changeTablePage(pendingPage);
        }
      } else if (from === "all") {
        if (data?.approvals?.length === 1) {
          changeTablePage(allPage === 1 ? allPage : allPage - 1);
        } else {
          changeTablePage(allPage);
        }
      }
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't approve. Try again later."
      );
    }
    setTableLoading(false);
  }

  async function rejectApproval(id, action, from) {
    setTableLoading(true);
    const apiResponse = await TargetApprovalActionApi(id, action);
    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.message === "Approval status updated successfully") {
      openNotificationSuccess("bottomRight", apiResponse.message);
      if (from === "pending") {
        if (data?.approvals?.length === 1) {
          changeTablePage(pendingPage === 1 ? pendingPage : pendingPage - 1);
        } else {
          changeTablePage(pendingPage);
        }
      } else if (from === "all") {
        if (data?.approvals?.length === 1) {
          changeTablePage(allPage === 1 ? allPage : allPage - 1);
        } else {
          changeTablePage(allPage);
        }
      }
    } else {
      openNotificationError("bottomRight", "Couldn't reject. Try again later.");
    }
    setTableLoading(false);
  }

  function changeTablePage(num) {
    getData(num);
  }

  function changeTab(key) {
    setLoading(true);
    if (key === "1") {
      setSelectedTab("all");
      getTargetApprovals(allPage, "");
    } else if (key === "2") {
      setSelectedTab("pending");
      getTargetApprovals(pendingPage, "Pending");
    } else if (key === "3") {
      setSelectedTab("approved");
      getTargetApprovals(approvedPage, "Approved");
    } else if (key === "4") {
      setSelectedTab("rejected");
      getTargetApprovals(rejectedPage, "Rejected");
    }
  }

  function getData(num) {
    if (selectedTab === "all") {
      getTargetApprovals(num, "");
      setAllPage(num);
    } else if (selectedTab === "pending") {
      getTargetApprovals(num, "Pending");
      setPendingPage(num);
    } else if (selectedTab === "approved") {
      getTargetApprovals(num, "Approved");
      setApprovedPage(num);
    } else if (selectedTab === "rejected") {
      getTargetApprovals(num, "Rejected");
      setRejectedPage(num);
    }
  }

  const left = <div className="pri-font text-lg">Target Approvals</div>;

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll"
        >
          <Tabs onChange={changeTab} defaultActiveKey="1" centered>
            <TabPane tab={<div className="w-32 text-center ">All</div>} key="1">
              <div className="px-6 pb-6">
                {!loading ? (
                  <TargetApprovalsTable
                    data={data?.approvals}
                    totalCount={data?.totalCount}
                    approveApproval={(id, action, from) =>
                      approveApproval(id, action, from)
                    }
                    rejectApproval={(id, action, from) =>
                      rejectApproval(id, action, from)
                    }
                    changePage={(num) => changeTablePage(num)}
                    current={allPage}
                    setPage={(num) => setAllPage(num)}
                    tableLoading={tableLoading}
                  />
                ) : (
                  <PageLoader />
                )}
              </div>
            </TabPane>
            <TabPane
              tab={<div className="w-32  text-center">Pending</div>}
              key="2"
            >
              <div className="px-6 pb-6">
                {!loading ? (
                  <TargetApprovalsTable
                    data={data?.approvals}
                    totalCount={data?.totalCount}
                    approveApproval={(id, action, from) =>
                      approveApproval(id, action, from)
                    }
                    rejectApproval={(id, action, from) =>
                      rejectApproval(id, action, from)
                    }
                    changePage={(num) => changeTablePage(num)}
                    current={pendingPage}
                    setPage={(num) => setPendingPage(num)}
                    tableLoading={tableLoading}
                  />
                ) : (
                  <PageLoader />
                )}
              </div>
            </TabPane>
            <TabPane
              tab={<div className="w-32 text-center ">Approved</div>}
              key="3"
            >
              <div className="px-6 pb-6">
                {!loading ? (
                  <TargetApprovalsTable
                    data={data?.approvals}
                    totalCount={data?.totalCount}
                    changePage={(num) => changeTablePage(num)}
                    current={approvedPage}
                    setPage={(num) => setApprovedPage(num)}
                    tableLoading={tableLoading}
                  />
                ) : (
                  <PageLoader />
                )}
              </div>
            </TabPane>
            <TabPane
              tab={<div className="w-32 text-center">Rejected</div>}
              key="4"
            >
              <div className="px-6 pb-6">
                {!loading ? (
                  <TargetApprovalsTable
                    data={data?.approvals}
                    totalCount={data?.totalCount}
                    changePage={(num) => changeTablePage(num)}
                    current={rejectedPage}
                    setPage={(num) => setRejectedPage(num)}
                    tableLoading={tableLoading}
                  />
                ) : (
                  <PageLoader />
                )}
              </div>
            </TabPane>
          </Tabs>
        </div>
      </Content>
    </>
  );
}

export default TargetApprovals;
